type UnderwritingClassificationInput = {
  business_type?: string | null;
  mcc?: string | null;
};

export type OnboardingClassificationInput = {
  business?: {
    underwriting_data?: UnderwritingClassificationInput | null;
  } | null;
};

export type OnboardingClassification = {
  isSchoolBusinessTypeResolved: boolean;
  isSchoolMcc: boolean;
  isNotForProfitSchool: boolean;
  validationMode: 'main' | 'school';
};

export const schoolMCCs = [
  '8211',
  '8220',
  '8241',
  '8244',
  '8249',
  '8299',
] as const;

export const notForProfitSchoolBusinessTypes = ['GOV', 'TAX_EXEMPT'] as const;

/**
 * Mirrors the onboarding-service school exception so UI routing can separate
 * school MCC presentation from the narrower not-for-profit validation path.
 */
export const getOnboardingClassification = (
  onboardingData: OnboardingClassificationInput,
): OnboardingClassification => {
  const underwritingData = onboardingData?.business?.underwriting_data || {};
  const mcc = underwritingData.mcc || '';
  const businessType = underwritingData.business_type || null;
  const isSchoolMcc = schoolMCCs.includes(mcc as (typeof schoolMCCs)[number]);
  const isSchoolBusinessTypeResolved = !isSchoolMcc || !!businessType;
  const isNotForProfitSchool =
    isSchoolMcc &&
    !!businessType &&
    notForProfitSchoolBusinessTypes.includes(
      businessType as (typeof notForProfitSchoolBusinessTypes)[number],
    );

  return {
    isSchoolBusinessTypeResolved,
    isSchoolMcc,
    isNotForProfitSchool,
    validationMode:
      isSchoolMcc && (!isSchoolBusinessTypeResolved || isNotForProfitSchool)
        ? 'school'
        : 'main',
  };
};
